// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1RWMJ","infoBtn":"quickbooks_infoBtn__2JlAX","formBox":"quickbooks_formBox__3oSb2","formFooter":"quickbooks_formFooter__3aAyF"};